<template src="./termsAndConditions.template.html"></template>

<script>
    // const socket = require('socket.io');


    export default {

        name: 'termsAndConditions',
        props: [],
        data() {
            return {
                confirmationNumber:null,
            };
        },
        methods: {
           
            GetReservationDetailById: function () {
                let vm = this;
                console.log("vm.$route.params.ReservationId======?", vm.$route.params.ReservationId);
                if (vm.$route.params.ReservationId == "-1") {
                    console.log("vm.unit", vm.unit);
                    vm.selectedUnit = vm.unit;
                    vm.showGuestDetails = true;
                    vm.ShowPaymentDetails = false;
                    // vm.ThankuPage = false;
                    vm.GetFolioLedgerTransDetails_beforesave();
                }
                else {
                    vm.showGuestDetails = false;
                    vm.ShowPaymentDetails = true;
                    // vm.ThankuPage = false;
                }
                let obj = {
                    ModuleAction: "GetReservationDetailById",
                    ReservationId: vm.$route.params.ReservationId,
                    BE_Id: null


                };

                let sucessCallback = function (response) {

                    if (response.data) {

                        console.log("GetReservationDetailById", response.data);

                        vm.guestInfo = response.data.guestInfo;
                        console.log("vm.guestInfo", vm.guestInfo);
                        vm.guestInfo.Emailaddress = response.data.additionalEmails[0].Emailaddress;
                        vm.guestInfo.PhoneNumber = response.data.additionalPhoneNumbers[0].PhoneNumber;
                        vm.searchCity = response.data.guestInfo.CityName;
                        vm.searchCountry = response.data.guestInfo.CountryName;
                        vm.searchState = response.data.guestInfo.StateName;
                       vm.confirmationNumber= response.data.guestInfo.ConfirmationNumber;
                      vm.statusname = response.data.reservationStatusObj.StatusName;


                         
                        if (response.data.roomInfo.UnitId) {
                            vm.selectedUnit = response.data.roomInfo;
                            vm.filterObj.startDate = response.data.roomInfo.StartDate;
                            vm.filterObj.endDate = response.data.roomInfo.EndDate;

                        }



                    }

                },
                    failureCallback = function (error) {
                        console.log(error);
                    };



                vm.$store.state.sendApiRequest("beApi/GetReservationDetailById", "post", obj, sucessCallback, failureCallback);





            },
            navigateToPaymentPage() {
                let vm = this;
                 
                console.log( "vm.$route.params.ReservationId====>", vm.$route.params.confirmationNumber);
               

                vm.$router.push("/guestInfoAndPayment/" + vm.$route.params.confirmationNumber );
               
            },


        },
        computed: {

        },
        created() {
        },
        watch: {
        },
        mounted() {
        //  this.GetReservationDetailById();
        let vm = this;
        vm.$store.state.bus.$emit("hidingSearch", false);

        }
    }

</script>


// WEBPACK FOOTER //
// src/components/termsAndConditions/termsAndConditions.vue